import React, { useContext } from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import { useNavigate, useParams } from "react-router-dom"

import ExtrasAndContradictionsContext from "context/extrasAndContradictions/ExtrasAndContradictionsContext"
import ProjectContext from "context/projects/projectContext"
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material"

const LayoutExtrasAndContradictions = ({ children }) => {
  const { projectId } = useParams()
  const { dispatchs, btnLoading, tree } = useContext(
    ExtrasAndContradictionsContext,
  )
  const { projectInfo } = useContext(ProjectContext)
  const navigate = useNavigate()

  const closeExtras = async () => {
    await dispatchs.closeExtras(projectId)
    navigate(`/budgeting/${projectId}`)
  }

  const hasParts = () => tree?.getTotalPartCount() > 0

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 3,
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" component="h1">
            Cambios
          </Typography>
        </Box>
        <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
          {hasParts() && (
            <Alert severity="error" sx={{ padding: "0px 16px" }}>
              {i18n.t("extras.alert")}
            </Alert>
          )}
        </Box>
        <Button
          color="branded"
          variant="contained"
          loading={btnLoading}
          sx={{ width: 190, height: 36 }}
          onClick={closeExtras}
        >
          {btnLoading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            i18n.t("extras.closeExtras")
          )}
        </Button>
      </Box>
      <Box sx={{ width: "100%" }}>{children}</Box>
    </>
  )
}

LayoutExtrasAndContradictions.propTypes = {
  children: PropTypes.node.isRequired,
}
export default LayoutExtrasAndContradictions
